import React from "react";
import ContactForm from "./ContactForm";
import { Mail, Dribbble } from "lucide-react";

const ContactInfo = () => {
  return (
    <>
      <div className="w-full lg:min-h-full flex flex-col md:flex-row justify-center items-center bg-neutral-200 ">
        {/* Left: Contact Form */}
        <div className="w-full md:w-1/2 ">
          <ContactForm />
        </div>

        {/* Right: Contact Info */}
        <div className="w-full md:w-[40%] mt-[-20px] md:mt-0 p-4 md:p-8 poppins-medium">
          <div className="rounded-lg bg-gray-50 shadow-lg">
            <h1 className="pt-5 px-5 text-lg md:text-xl poppins-semibold uppercase  text-gray-600 text-center">
              Contact Info
            </h1>
            <hr className="border-t-2 border-gray-400 w-full" />

            <div className="text-base md:text-xl text-gray-500 px-6 py-5 flex flex-col gap-6">
              <p className="flex items-center text-xs md:text-base gap-3">
                <Mail className="size-7 bg-gray-200 rounded-lg" />
                contact.onlineindianmarket@gmail.com
              </p>

              <p className="flex items-center text-xs md:text-base gap-3">
                <Dribbble className="size-7 bg-gray-200 rounded-lg" />
                www.onlineindianmarket@gmail.com
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactInfo;
